/**
 * 2단 카테고리의 일본어·중국어 라벨. 키는 "axis:majorId" 또는 "axis:majorId:subId".
 * 빠진 항목은 영어로 폴백된다 (taxonomy.ts 의 labelOf).
 */
export const TAXONOMY_I18N: Record<string, { ja: string; zh: string }> = {
  // ── product majors ──
  'product:sauce': { ja: 'ソース・調味料', zh: '酱料·调味料' },
  'product:meal-kit': { ja: 'ミールキット', zh: '料理包' },
  'product:beverage': { ja: '飲料', zh: '饮料' },
  'product:coffee': { ja: 'コーヒー', zh: '咖啡' },
  'product:tea': { ja: '茶・ハーブ飲料', zh: '茶·草本饮品' },
  'product:alcohol': { ja: '酒類', zh: '酒类' },
  'product:misc': { ja: 'その他', zh: '其他' },
  'product:frozen': { ja: '冷凍食品', zh: '冷冻食品' },
  'product:hmr': { ja: '調理済み食品', zh: '即食餐' },
  'product:snacks': { ja: 'スナック・菓子', zh: '零食' },
  'product:bakery': { ja: '製菓・製パン', zh: '烘焙·糕点' },
  'product:dairy': { ja: '乳製品・発酵乳', zh: '乳制品·发酵乳' },
  'product:meat': { ja: '食肉加工品', zh: '肉类加工' },
  'product:seafood': { ja: '水産加工品', zh: '水产加工' },
  'product:supplement': { ja: '健康食品', zh: '保健食品' },
  'product:pickled': { ja: '漬物・保存・発酵食品', zh: '腌渍·保存·发酵食品' },
  'product:noodles': { ja: '麺類', zh: '面类' },
  'product:canned': { ja: '缶詰・瓶詰', zh: '罐头' },
  'product:dried': { ja: '乾燥・フリーズドライ', zh: '干制/冻干' },
  'product:baby': { ja: 'ベビーフード', zh: '婴幼儿食品' },
  'product:sports': { ja: 'スポーツ栄養・体重管理', zh: '运动营养·体重管理' },
  'product:pet': { ja: 'ペットフード・おやつ', zh: '宠物食品·零食' },
  'product:oils': { ja: '油脂類', zh: '油脂' },
  'product:grains': { ja: '穀物・豆・ナッツ', zh: '谷物豆类坚果' },
  'product:plant-based': { ja: 'プラントベース・ヴィーガン代替', zh: '植物基·纯素替代' },
  'product:produce': { ja: '果物・野菜加工', zh: '果蔬加工' },
  'product:tteok': { ja: '餅・韓国伝統菓子', zh: '韩式年糕·韩果' },
  'product:jang': { ja: '韓国の発酵醤（ジャン）', zh: '韩式发酵酱类' },
  // ── product subs ──
  'product:sauce:liquid': { ja: '液体ソース', zh: '液体酱料' },
  'product:sauce:ramen-soup': { ja: 'ラーメンスープ（粉末）', zh: '拉面汤粉' },
  'product:sauce:spice-blend': {
    ja: 'スパイスブレンド・シーズニング（単体含む）',
    zh: '混合香辛料·调味粉（含单一）',
  },
  'product:sauce:marinade': { ja: '漬けだれ・マリネ', zh: '调味腌汁·腌料' },
  'product:sauce:seasoning-base': { ja: '粉末・顆粒ソースベース', zh: '粉末·颗粒调味底料' },
  'product:sauce:dipping': { ja: 'ディップソース', zh: '蘸酱' },
  'product:sauce:jang': { ja: 'テンジャン・その他の発酵醤', zh: '大酱·其他发酵酱' },
  'product:sauce:worcester-steak': { ja: 'ウスター・ステーキソース', zh: '伍斯特/牛排酱' },
  'product:sauce:mayo': { ja: 'マヨネーズ', zh: '蛋黄酱' },
  'product:sauce:dressing': { ja: 'ドレッシング', zh: '沙拉酱' },
  'product:sauce:pesto': { ja: 'ペスト', zh: '青酱' },
  'product:sauce:chutney': { ja: 'チャツネ', zh: '酸辣酱' },
  'product:sauce:salsa': { ja: 'サルサ', zh: '莎莎酱' },
  'product:sauce:aioli': { ja: 'アイオリ', zh: '蒜香蛋黄酱' },
  'product:sauce:tartar': { ja: 'タルタルソース', zh: '塔塔酱' },
  'product:sauce:ssamjang': { ja: 'サムジャン', zh: '包饭酱' },
  'product:sauce:bbq': { ja: 'BBQ・焼き肉ソース', zh: '烧烤酱' },
  'product:sauce:hot-sauce': {
    ja: 'ホットソース・辛口ソース（発酵熟成含む）',
    zh: '辣酱·香辣酱（含发酵熟成）',
  },
  'product:sauce:oyster': { ja: 'オイスターソース', zh: '蚝油' },
  'product:sauce:bearnaise': { ja: 'ベアルネーズ', zh: '伯纳西酱' },
  'product:sauce:demi-glace': { ja: 'デミグラス', zh: '浓缩牛肉酱' },
  'product:sauce:fire-chicken': { ja: '激辛チキンソース', zh: '火鸡辣酱' },
  'product:sauce:cream-pasta': {
    ja: 'パスタ・クリームソース（トマト・オイル含む）',
    zh: '意面酱·奶油酱（含番茄·油基）',
  },
  'product:sauce:aged-gochujang': {
    ja: 'コチュジャン（長期熟成含む）',
    zh: '韩式辣酱（含长期发酵）',
  },
  'product:sauce:truffle-mayo': { ja: 'トリュフマヨ（チューブ）', zh: '松露蛋黄酱（管装）' },
  'product:sauce:ganjang': { ja: '醤油（カンジャン）', zh: '酱油' },
  'product:sauce:ramen-flakes': { ja: 'ラーメンのかやく（乾燥具材）', zh: '方便面脱水菜包' },
  'product:sauce:ramen-oil': { ja: 'ラーメン用調味油', zh: '方便面调味油包' },
  'product:sauce:vinegar': { ja: '酢（醸造酢・果実酢・発酵酢）', zh: '醋（酿造醋·果醋·发酵醋）' },
  'product:meal-kit:soup-stew': { ja: 'スープ・鍋キット', zh: '汤/炖菜料理包' },
  'product:meal-kit:stir-fry': { ja: '炒め・焼きキット', zh: '炒/烤料理包' },
  'product:meal-kit:noodle': { ja: '麺キット', zh: '面食料理包' },
  'product:meal-kit:side-dish': { ja: '副菜セット', zh: '小菜套装' },
  'product:meal-kit:pasta': { ja: 'パスタキット', zh: '意面料理包' },
  'product:meal-kit:hot-pot': { ja: '鍋・しゃぶしゃぶキット', zh: '火锅/涮锅料理包' },
  'product:meal-kit:salad': {
    ja: 'サラダキット（洗浄野菜+ドレッシング）',
    zh: '沙拉套装（净菜+沙拉酱）',
  },
  'product:meal-kit:budae': { ja: 'プデチゲキット', zh: '部队锅料理包' },
  'product:meal-kit:gambas': { ja: 'ガンバスキット', zh: '蒜香虾料理包' },
  'product:meal-kit:mille-feuille': { ja: 'ミルフィーユ鍋キット', zh: '千层锅料理包' },
  'product:meal-kit:malatang': { ja: 'マーラータンキット', zh: '麻辣烫料理包' },
  'product:meal-kit:seafood-steam': { ja: '海鮮蒸しキット', zh: '海鲜蒸料理包' },
  'product:meal-kit:seafood-pancake': { ja: '海鮮チヂミキット', zh: '海鲜煎饼料理包' },
  'product:meal-kit:chilled-pasta': { ja: 'チルド・レストランパスタ', zh: '冷藏餐厅意面' },
  'product:meal-kit:tteokbokki': {
    ja: 'トッポッキ・韓国軽食ミールキット',
    zh: '炒年糕·韩式小吃料理包',
  },
  'product:meal-kit:other': { ja: 'その他のミールキット', zh: '其他料理包' },
  'product:beverage:soda': { ja: '炭酸飲料', zh: '碳酸饮料' },
  'product:beverage:juice': { ja: '果汁・野菜ジュース', zh: '果蔬汁' },
  'product:beverage:rtd-tea': { ja: 'RTDティー', zh: '即饮茶' },
  'product:beverage:functional': { ja: '発酵・機能性飲料', zh: '发酵/功能饮料' },
  'product:beverage:soda-base': { ja: 'ソーダベース（シロップ）', zh: '汽水糖浆' },
  'product:beverage:protein': { ja: 'プロテイン飲料', zh: '蛋白饮料' },
  'product:beverage:kombucha': { ja: 'コンブチャ', zh: '康普茶' },
  'product:beverage:smoothie': { ja: 'スムージー', zh: '奶昔/思慕雪' },
  'product:beverage:ade': { ja: 'エード（果汁炭酸）', zh: '果味气泡饮' },
  'product:beverage:electrolyte': { ja: 'スポーツドリンク', zh: '电解质饮料' },
  'product:beverage:plant-milk': { ja: '植物性ミルク', zh: '植物奶' },
  'product:beverage:probiotic': { ja: '乳酸菌飲料', zh: '益生菌饮料' },
  'product:beverage:sikhye': {
    ja: 'シッケ・スジョングァ（伝統飲料）',
    zh: '甜米露·水正果（传统饮品）',
  },
  'product:beverage:cold-brew-latte': { ja: 'コールドブリューラテRTD', zh: '冷萃拿铁（即饮）' },
  'product:beverage:energy': { ja: '機能性・エナジードリンク', zh: '功能·能量饮料' },
  'product:beverage:collagen': {
    ja: 'コラーゲン・インナービューティー飲料',
    zh: '胶原蛋白·内调美容饮',
  },
  'product:beverage:condition': { ja: '二日酔い対策飲料', zh: '解酒饮料' },
  'product:beverage:zero-soda': { ja: 'ゼロ・低糖炭酸飲料', zh: '零糖·低糖汽水' },
  'product:beverage:vitamin-water': { ja: 'ビタミンウォーター', zh: '维生素水' },
  'product:beverage:hpp-shot': { ja: 'HPPコールドプレスショット', zh: 'HPP冷压果汁小瓶' },
  'product:beverage:aseptic-plant-protein': {
    ja: '無菌植物性プロテイン飲料',
    zh: '无菌植物蛋白饮',
  },
  'product:beverage:juice-concentrate': { ja: '濃縮果汁・濃縮野菜汁', zh: '浓缩果蔬汁' },
  'product:beverage:health-juice': {
    ja: '健康ジュース・エキス（パウチ）',
    zh: '养生汁·浓缩液（袋装）',
  },
  'product:coffee:rtd': { ja: 'RTDコーヒー', zh: '即饮咖啡' },
  'product:coffee:cold-brew-concentrate': { ja: 'コールドブリュー原液', zh: '冷萃浓缩液' },
  'product:coffee:drip-bag': { ja: 'ドリップバッグ', zh: '挂耳咖啡' },
  'product:coffee:ground': { ja: 'コーヒー豆（ホール・粉）', zh: '咖啡豆（整豆·研磨）' },
  'product:coffee:mix-stick': { ja: 'スティックコーヒー', zh: '条装速溶咖啡' },
  'product:coffee:capsule': { ja: 'カプセルコーヒー', zh: '胶囊咖啡' },
  'product:coffee:rtd-latte': { ja: 'RTDラテ', zh: '即饮拿铁' },
  'product:coffee:instant': { ja: 'インスタントコーヒー', zh: '速溶咖啡' },
  'product:coffee:bulk-concentrate': { ja: '業務用コーヒー原液', zh: '咖啡浓缩液（散装）' },
  'product:coffee:cold-brew-bag': { ja: 'コールドブリューバッグ', zh: '冷萃茶包式咖啡' },
  'product:coffee:nitro': { ja: 'コールドブリュー缶（ニトロ含む）', zh: '冷萃咖啡罐装（含氮气）' },
  'product:coffee:specialty-drip': { ja: 'スペシャルティドリップバッグ', zh: '精品挂耳咖啡' },
  'product:tea:leaf': { ja: '茶葉・ティーバッグ', zh: '茶叶·茶包' },
  'product:tea:herbal': { ja: 'ハーブティー・ブレンド', zh: '花草茶·拼配茶' },
  'product:tea:powder': { ja: '粉末茶・抹茶', zh: '茶粉·抹茶' },
  'product:tea:cheong': { ja: '果実茶のもと・韓国伝統茶', zh: '果酱茶·韩式传统茶' },
  'product:tea:concentrate': { ja: '濃縮茶・ティーシロップ', zh: '浓缩茶·茶糖浆' },
  'product:tea:rtd': { ja: 'RTD茶（ボトル・缶）', zh: '即饮茶（瓶装·罐装）' },
  'product:tea:functional': { ja: '機能性茶', zh: '功能茶' },
  'product:tea:kombucha': { ja: 'コンブチャ（発酵茶）', zh: '康普茶（发酵茶）' },
  'product:alcohol:traditional': {
    ja: '伝統酒（タクジュ・薬酒・マッコリ・清酒）',
    zh: '传统酒（浊酒·药酒·马格利·清酒）',
  },
  'product:alcohol:fruit-wine': {
    ja: '果実酒（ワイン・シードル含む）',
    zh: '果酒（含葡萄酒·苹果酒）',
  },
  'product:alcohol:liqueur': { ja: 'リキュール', zh: '利口酒' },
  'product:alcohol:highball': { ja: 'ハイボール・RTDカクテル', zh: '高球/即饮鸡尾酒' },
  'product:alcohol:craft-beer': { ja: 'ビール（クラフト含む）', zh: '啤酒（含精酿）' },
  'product:alcohol:non-alcoholic-beer': { ja: 'ノンアルコールビール', zh: '无酒精啤酒' },
  'product:alcohol:distilled-soju': { ja: '焼酎（蒸留式含む）', zh: '烧酒（含蒸馏式）' },
  'product:alcohol:fresh-makgeolli': { ja: '生マッコリ', zh: '鲜马格利酒' },
  'product:alcohol:oak-aged': { ja: '樽熟成蒸留酒', zh: '橡木桶陈酿烈酒' },
  'product:alcohol:sparkling-traditional': {
    ja: 'スパークリング発酵酒（自然発酵の炭酸）',
    zh: '起泡发酵酒（自然发酵起泡）',
  },
  'product:alcohol:yuzu-yakju': { ja: '柚子の低アルコールヤクチュ', zh: '柚子低度韩国清米酒' },
  'product:alcohol:omija-sparkling': { ja: '五味子スパークリング', zh: '五味子气泡酒' },
  'product:alcohol:gin-vodka': {
    ja: 'ジン・ウォッカ（無熟成蒸留酒）',
    zh: '金酒·伏特加（未陈酿烈酒）',
  },
  'product:misc:powder': { ja: '粉末ミックス', zh: '粉末冲调' },
  'product:misc:seasoning': { ja: 'シーズニング', zh: '调味料' },
  'product:misc:snack': { ja: 'スナック', zh: '零食' },
  'product:misc:treat': { ja: 'おやつ', zh: '小食' },
  'product:misc:dessert': { ja: 'デザート', zh: '甜点' },
  'product:misc:bakery': { ja: 'ベーカリー', zh: '烘焙' },
  'product:misc:fermented': { ja: '発酵食品', zh: '发酵食品' },
  'product:misc:spread': { ja: 'スプレッド（ジャム・バター）', zh: '涂抹酱（果酱/黄油）' },
  'product:misc:syrup-topping': { ja: 'シロップ・トッピングソース', zh: '糖浆/淋酱' },
  'product:misc:ssamjang-tube': { ja: '熟成サムジャン（チューブ）', zh: '陈酿包饭酱（管装）' },
  'product:misc:honey': { ja: '蜂蜜・米飴（スティック蜂蜜含む）', zh: '蜂蜜·米糖浆（含蜂蜜条）' },
  'product:frozen:dumpling': { ja: '餃子・マンドゥ', zh: '饺子' },
  'product:frozen:fried-rice': { ja: '冷凍チャーハン', zh: '冷冻炒饭' },
  'product:frozen:bar-snack': { ja: '冷凍おつまみ', zh: '冷冻下酒菜' },
  'product:frozen:cutlet': { ja: '冷凍カツ', zh: '冷冻炸排' },
  'product:frozen:noodle': { ja: '冷凍麺', zh: '冷冻面' },
  'product:frozen:ice-pop': { ja: '氷菓・アイスバー・シャーベット', zh: '冰棍·雪葩（果味冰品）' },
  'product:frozen:snack': {
    ja: '冷凍ピザ・おやつ（ホットドッグ・ホットク・たい焼き）',
    zh: '冷冻披萨·小吃（热狗·糖饼·鲷鱼烧）',
  },
  'product:frozen:iqf': { ja: '冷凍果物・野菜（IQF）', zh: '速冻果蔬（IQF）' },
  'product:frozen:other': { ja: 'その他の冷凍加工食品', zh: '其他冷冻加工食品' },
  'product:hmr:retort-soup': { ja: 'レトルトスープ・鍋', zh: '软罐头汤/炖菜' },
  'product:hmr:cup-rice': { ja: 'カップごはん', zh: '杯饭' },
  'product:hmr:porridge': { ja: 'おかゆ', zh: '粥' },
  'product:hmr:bowl-sauce': { ja: '丼ソース', zh: '盖饭酱' },
  'product:hmr:instant-pasta': { ja: 'インスタントパスタ', zh: '速食意面' },
  'product:hmr:instant-rice': { ja: 'パックご飯', zh: '即食米饭' },
  'product:hmr:banchan': { ja: '韓国惣菜（炒め・煮物・和え物）', zh: '即食小菜（炒·卤·拌）' },
  'product:hmr:dosirak': {
    ja: '弁当・キンパ・サンドイッチ（そのまま食べる）',
    zh: '便当·紫菜包饭·三明治（即食）',
  },
  'product:snacks:chips': { ja: 'チップス', zh: '薯片/脆片' },
  'product:snacks:bar': { ja: 'シリアル・ナッツバー', zh: '谷物/坚果棒' },
  'product:snacks:gummy': { ja: 'グミ', zh: '软糖' },
  'product:snacks:popcorn': { ja: 'ポップコーン', zh: '爆米花' },
  'product:snacks:chocolate': { ja: 'チョコレート', zh: '巧克力' },
  'product:snacks:candy': {
    ja: 'キャンディ・キャラメル（飴・ヌガー・マシュマロ）',
    zh: '糖果·焦糖（牛轧糖·棉花糖·麦芽糖）',
  },
  'product:snacks:protein-snack': { ja: 'プロテインスナック', zh: '蛋白零食' },
  'product:bakery:premix': { ja: 'ベーキングミックス', zh: '烘焙预拌粉' },
  'product:bakery:frozen-dough': { ja: '冷凍生地', zh: '冷冻面团' },
  'product:bakery:cookie': { ja: 'クッキー・ビスケット・焼き菓子', zh: '曲奇·饼干·烘焙点心' },
  'product:bakery:cake': { ja: 'ケーキ', zh: '蛋糕' },
  'product:bakery:bread': {
    ja: 'パン類（食パン・塩パン・クロワッサン・ペストリー）',
    zh: '面包类（吐司·盐面包·可颂·酥皮）',
  },
  'product:dairy:yogurt': { ja: '発酵乳・ヨーグルト', zh: '发酵乳·酸奶' },
  'product:dairy:natural-cheese': { ja: 'ナチュラルチーズ', zh: '天然奶酪' },
  'product:dairy:processed-cheese': { ja: 'プロセスチーズ', zh: '再制奶酪' },
  'product:dairy:ice-cream': { ja: 'アイスクリーム・ジェラート', zh: '冰淇淋/意式冰淇淋' },
  'product:dairy:butter-cream': {
    ja: 'バター・クリーム（発酵バター・生クリーム）',
    zh: '黄油·奶油（发酵黄油·鲜奶油）',
  },
  'product:dairy:pudding': {
    ja: 'プリン・カップデザート（カスタード・パンナコッタ）',
    zh: '布丁·杯装甜点（卡仕达·意式奶冻）',
  },
  'product:meat:sausage': { ja: 'ソーセージ・フランク', zh: '香肠·法兰克福香肠' },
  'product:meat:ham': { ja: 'ハム・加工肉', zh: '火腿·加工肉' },
  'product:meat:nugget': { ja: 'ナゲット・成形肉', zh: '鸡块·重组肉' },
  'product:meat:patty': { ja: 'パティ・トッカルビ', zh: '肉饼·韩式牛肉饼' },
  'product:meat:jerky': { ja: 'ジャーキー', zh: '肉干' },
  'product:meat:chicken-breast': {
    ja: '鶏むね肉加工品（ソーセージ・キューブ・ステーキ・バー）',
    zh: '鸡胸肉制品（香肠·肉丁·肉排·肉棒）',
  },
  'product:meat:marinated': {
    ja: 'ベーコン・味付け肉（プルコギ・カルビ・タッカルビ）',
    zh: '培根·调味腌肉（烤肉·排骨·铁板鸡）',
  },
  'product:meat:jokbal': { ja: 'チョッパル・ゆで豚', zh: '酱猪蹄·白切肉' },
  'product:meat:egg': {
    ja: '卵加工品（焼き卵・燻製卵・醤油漬け卵）',
    zh: '蛋制品（烤蛋·熏蛋·酱蛋）',
  },
  'product:seafood:fish-cake': { ja: '練り物・カニカマ', zh: '鱼糕/蟹柳' },
  'product:seafood:jeotgal': { ja: '塩辛', zh: '腌海鲜' },
  'product:seafood:smoked-salmon': { ja: 'スモークサーモン', zh: '烟熏三文鱼' },
  'product:seafood:semi-dried': { ja: '半干し魚', zh: '半干鱼' },
  'product:seafood:seaweed': { ja: '味付け海苔', zh: '调味海苔' },
  'product:seafood:soy-marinated': {
    ja: '醤油漬け魚介（ケジャン・サーモン・エビ）',
    zh: '酱腌海鲜（酱蟹·三文鱼·虾）',
  },
  'product:seafood:dried-seasoned': {
    ja: '味付け乾燥魚介（さきいか・カワハギ）',
    zh: '调味海鲜干货（鱿鱼丝·马面鱼片）',
  },
  'product:seafood:other': { ja: 'その他の水産加工品', zh: '其他水产加工品' },
  'product:supplement:powder-stick': { ja: '粉末スティック', zh: '粉末条' },
  'product:supplement:jelly-stick': { ja: 'ゼリースティック', zh: '果冻条' },
  'product:supplement:tablet': { ja: '錠剤・カプセル', zh: '片剂/胶囊' },
  'product:supplement:ampoule': { ja: '液体アンプル', zh: '液体安瓿' },
  'product:supplement:gummy': { ja: 'グミ', zh: '软糖' },
  'product:supplement:red-ginseng': {
    ja: '紅参・高麗人参（濃縮液・スティック・スライス）',
    zh: '红参·人参（浓缩液·条装·切片）',
  },
  'product:pickled:kimchi': { ja: 'キムチ', zh: '泡菜' },
  'product:pickled:jangajji': { ja: '醤油漬け', zh: '酱油腌菜' },
  'product:pickled:pickle': { ja: 'ピクルス', zh: '醋渍泡菜' },
  'product:pickled:fermented-pickle': { ja: '発酵漬物', zh: '发酵腌菜' },
  'product:pickled:jeotgal': { ja: '塩辛・魚醤（ジョッカル）', zh: '腌海鲜·鱼露（韩式）' },
  'product:noodles:fresh': { ja: '生麺', zh: '鲜面' },
  'product:noodles:dried': { ja: '乾麺', zh: '干面' },
  'product:noodles:cooked': { ja: 'ゆで麺', zh: '熟面' },
  'product:noodles:frozen': { ja: '冷凍麺', zh: '冷冻面' },
  'product:noodles:cup': { ja: 'カップ麺', zh: '杯面' },
  'product:noodles:instant-rice': { ja: 'パックご飯・即席ご飯', zh: '即食米饭·速食饭' },
  'product:canned:tuna': { ja: 'ツナ缶', zh: '金枪鱼罐头' },
  'product:canned:fruit': { ja: 'フルーツ缶', zh: '水果罐头' },
  'product:canned:tomato': { ja: 'トマト缶（ホール・ペースト）', zh: '番茄罐头（整番茄·番茄膏）' },
  'product:canned:beans': { ja: '豆の缶詰', zh: '豆类罐头' },
  'product:canned:soup': { ja: 'スープ・おかゆ缶', zh: '汤/粥罐头' },
  'product:canned:vegetable': {
    ja: '野菜の缶詰（コーン・きのこ・たけのこ）',
    zh: '蔬菜罐头（玉米·蘑菇·竹笋）',
  },
  'product:dried:freeze-dried-produce': { ja: 'フリーズドライ果物・野菜', zh: '冻干果蔬' },
  'product:dried:dried-greens': { ja: '乾燥野菜・山菜', zh: '干菜' },
  'product:dried:jerky': { ja: 'ジャーキー', zh: '肉干' },
  'product:dried:soup-block': {
    ja: '乾燥スープ・ブロック・だし（固形・だしパック）',
    zh: '干汤料·汤块·高汤（汤包）',
  },
  'product:dried:freeze-dried-coffee': { ja: 'フリーズドライコーヒー', zh: '冻干咖啡' },
  'product:dried:other': { ja: 'その他の乾燥食品', zh: '其他干制食品' },
  'product:baby:pouch': { ja: 'ベビーフードパウチ', zh: '婴儿辅食袋' },
  'product:baby:puffs': { ja: 'ベビー菓子・パフ', zh: '婴儿饼干·泡芙' },
  'product:baby:formula': { ja: '粉ミルク', zh: '配方奶粉' },
  'product:baby:drink': { ja: '幼児向け飲料', zh: '儿童饮料' },
  'product:sports:protein-powder': { ja: 'プロテインパウダー', zh: '蛋白粉' },
  'product:sports:protein-bar': { ja: 'プロテインバー', zh: '蛋白棒' },
  'product:sports:shake': { ja: '置き換えシェイク', zh: '代餐奶昔' },
  'product:sports:electrolyte-powder': { ja: 'BCAA・電解質', zh: 'BCAA·电解质' },
  'product:sports:high-protein': { ja: '鶏むね肉・高たんぱく加工品', zh: '鸡胸肉·高蛋白制品' },
  'product:pet:baked': { ja: '手作りおやつ', zh: '手工零食' },
  'product:pet:freeze-dried': { ja: 'フリーズドライおやつ', zh: '冻干零食' },
  'product:pet:wet-pouch': { ja: 'ウェットパウチ', zh: '湿粮包' },
  'product:pet:dental': { ja: 'デンタルガム', zh: '洁牙咬胶' },
  'product:pet:dry-food': { ja: 'ドライ・ウェットフード（主食）', zh: '宠物干粮·湿粮（主粮）' },
  'product:oils:infused': { ja: 'フレーバーオイル', zh: '风味油' },
  'product:oils:blended': { ja: 'ブレンド食用油', zh: '调和油' },
  'product:oils:pressed': { ja: '焙煎圧搾油（ごま・えごま）', zh: '焙炒压榨油（芝麻/紫苏）' },
  'product:oils:spread': { ja: '油脂スプレッド（マーガリン類）', zh: '油脂涂抹酱（人造黄油类）' },
  'product:oils:shortening': { ja: 'ショートニング・加工油脂', zh: '起酥油·加工油脂' },
  'product:oils:spray': { ja: 'スプレーオイル', zh: '喷雾油' },
  'product:oils:powdered': { ja: '粉末油脂', zh: '粉末油脂' },
  'product:grains:cereal': { ja: 'シリアル・グラノーラ', zh: '麦片/格兰诺拉' },
  'product:grains:grain-powder': { ja: '穀物粉・禅食・ミスッカル', zh: '谷物粉·禅食·韩式五谷粉' },
  'product:grains:soy': { ja: '大豆加工品', zh: '豆制品' },
  'product:grains:nut-butter': { ja: 'ナッツバター', zh: '坚果酱' },
  'product:grains:roasted-nuts': { ja: 'ロースト・味付けナッツ', zh: '烘焙·调味坚果' },
  'product:grains:granola-bar': { ja: 'グラノーラバー', zh: '谷物棒' },
  'product:grains:starch': { ja: 'でんぷん', zh: '淀粉' },
  'product:grains:muk': {
    ja: 'ムク（どんぐり・緑豆・そばのゼリー）',
    zh: '凉粉（橡子·绿豆·荞麦）',
  },
  'product:plant-based:plant-meat': {
    ja: '植物性ミート（パティ・ナゲット・ソーセージ・ミンチ）',
    zh: '植物肉（肉饼·块·香肠·肉末）',
  },
  'product:plant-based:tofu-tempeh': { ja: '豆腐・テンペ', zh: '豆腐·天贝' },
  'product:plant-based:dairy-alt': { ja: '植物性ヨーグルト・チーズ', zh: '植物基酸奶·奶酪' },
  'product:plant-based:vegan-meal': { ja: 'ヴィーガン惣菜・弁当', zh: '纯素即食餐' },
  'product:plant-based:vegan-bakery': { ja: 'ヴィーガンベーカリー', zh: '纯素烘焙·甜点' },
  'product:plant-based:plant-milk': { ja: 'プラントベースミルク', zh: '植物基牛奶' },
  'product:plant-based:plant-protein': { ja: '植物性たんぱく製品', zh: '植物蛋白制品' },
  'product:produce:jam': { ja: 'ジャム・フルーツスプレッド', zh: '果酱·水果涂抹酱' },
  'product:produce:puree': { ja: 'ピューレ', zh: '果蔬泥' },
  'product:produce:dried': { ja: 'ドライフルーツ・野菜', zh: '果蔬干' },
  'product:produce:candied': { ja: '砂糖漬け・コンポート', zh: '蜜饯/糖渍' },
  'product:produce:paste': { ja: 'ペースト', zh: '果蔬酱' },
  'product:produce:iqf': { ja: '冷凍果物・野菜（IQF）', zh: '速冻果蔬（IQF）' },
  'product:tteok:steamed': {
    ja: '蒸し餅（ソルギ・シルトック・ソンピョン）',
    zh: '蒸糕（白雪糕·甑糕·松饼）',
  },
  'product:tteok:pounded': {
    ja: 'つき餅（インジョルミ・チョルピョン・カレトック）',
    zh: '打糕（豆面糕·切糕·条糕）',
  },
  'product:tteok:filled': { ja: '大福・あん入り餅', zh: '糯米糍·大福' },
  'product:tteok:cooking': {
    ja: '料理用餅（トッポッキ・トック用）',
    zh: '料理用年糕（炒年糕·年糕汤）',
  },
  'product:tteok:hangwa': {
    ja: '韓菓（薬菓・ユグァ・カンジョン）',
    zh: '韩果（药果·油果·米花糖）',
  },
  'product:tteok:yanggaeng': { ja: '羊羹・あん', zh: '羊羹·豆沙馅' },
  'product:jang:gochujang': { ja: 'コチュジャン', zh: '韩式辣椒酱' },
  'product:jang:doenjang': { ja: 'テンジャン（韓国味噌）', zh: '韩式大酱' },
  'product:jang:ganjang': { ja: 'カンジャン（韓国醤油）', zh: '韩式酱油' },
  'product:jang:ssamjang': { ja: 'サムジャン（合わせ醤）', zh: '包饭酱（混合酱）' },
  'product:jang:other': {
    ja: 'その他の発酵醤（清麹醤・春醤・マクジャン）',
    zh: '其他发酵酱（清麴酱·春酱·粗大酱）',
  },
  // ── 2026-11-01 전수 확인 뒤 (대표 지시 "주류 종류별과 건조·동결건조 자세하게 세분화") ──
  'product:alcohol:takju': { ja: 'タクジュ・マッコリ', zh: '浊酒·马格利' },
  // 약주·청주는 한국 음을 앞에 둔다. 일본어 清酒는 사케, 薬酒·药酒는 약재를 담근 술로 읽혀서다 (사케 칸은 日本酒)
  'product:alcohol:yakju': {
    ja: 'ヤクチュ・チョンジュ（韓国の澄んだ米酒）',
    zh: '韩国清米酒（药酒·清酒）',
  },
  'product:alcohol:sake': { ja: '日本酒', zh: '日本清酒' },
  'product:alcohol:wine': {
    ja: 'ワイン（赤・白・スパークリング）',
    zh: '葡萄酒（红·白·起泡）',
  },
  'product:alcohol:cider': { ja: 'シードル・果実酒', zh: '苹果酒·果酒' },
  'product:alcohol:soju-diluted': { ja: '焼酎（希釈式）', zh: '烧酒（稀释式）' },
  'product:alcohol:soju-distilled': { ja: '焼酎（蒸留式）', zh: '烧酒（蒸馏式）' },
  'product:alcohol:baijiu': { ja: '高粱酒・白酒', zh: '高粱酒·白酒' },
  'product:alcohol:whisky': { ja: 'ウイスキー', zh: '威士忌' },
  'product:alcohol:brandy': { ja: 'ブランデー', zh: '白兰地' },
  'product:alcohol:gin': { ja: 'ジン', zh: '金酒' },
  'product:alcohol:vodka': { ja: 'ウォッカ', zh: '伏特加' },
  'product:alcohol:rum': { ja: 'ラム', zh: '朗姆酒' },
  'product:alcohol:tequila': { ja: 'テキーラ・メスカル', zh: '龙舌兰·梅斯卡尔' },
  'product:dried:freeze-dried-fruit': { ja: 'フリーズドライフルーツ', zh: '冻干水果' },
  'product:dried:freeze-dried-vegetable': { ja: 'フリーズドライ野菜', zh: '冻干蔬菜' },
  'product:dried:dried-fruit': {
    ja: 'ドライフルーツ（干し柿・レーズン・マンゴー）',
    zh: '水果干（柿饼·葡萄干·芒果干）',
  },
  'product:dried:dried-mushroom': { ja: '乾燥きのこ', zh: '干菌菇' },
  'product:dried:produce-powder': { ja: '野菜・果物パウダー', zh: '果蔬粉' },
  'product:dried:herb': { ja: 'ドライハーブ・香味葉', zh: '干香草·香叶' },
  'product:dried:tofu-skin': { ja: '湯葉・乾燥豆腐', zh: '腐竹·干豆腐' },
  // ── menu majors ──
  'menu:main': { ja: 'メイン料理', zh: '主菜' },
  'menu:rice-noodle': { ja: 'ごはん・麺', zh: '饭/面' },
  'menu:intl': { ja: '各国・洋食メイン', zh: '国际·西式主菜' },
  'menu:soup': { ja: 'スープ・鍋', zh: '汤/炖菜' },
  'menu:side': { ja: 'サイド・前菜', zh: '配菜/前菜' },
  'menu:anju': { ja: 'おつまみ', zh: '下酒菜' },
  'menu:dessert': { ja: 'デザート', zh: '甜点' },
  'menu:drinks': { ja: 'ドリンク・お茶', zh: '饮品/茶' },
  // ── menu subs ──
  'menu:main:main.grill': { ja: '焼き・直火', zh: '烤/炭烤' },
  'menu:main:main.wok': { ja: '炒め（中華鍋）', zh: '炒（锅炒）' },
  'menu:main:main.braise': { ja: '煮物', zh: '炖煮' },
  'menu:main:main.steam': { ja: '蒸し（密閉・圧力）', zh: '蒸（密闭/高压）' },
  'menu:main:main.fry': { ja: '揚げ物', zh: '油炸' },
  'menu:main:main.pancake': { ja: 'チヂミ・鉄板焼き', zh: '煎饼（铁板）' },
  'menu:main:main.raw': { ja: '刺身・生食', zh: '生食/刺身' },
  'menu:main:main.roast': { ja: 'ステーキ・ロースト', zh: '牛排/烤箱烤' },
  'menu:main:main.smoke': { ja: '燻製・BBQ（低温長時間）', zh: '烟熏/慢烤' },
  'menu:rice-noodle:rice-noodle.rice-bowl': { ja: '丼', zh: '盖饭' },
  'menu:rice-noodle:rice-noodle.fried-rice': { ja: 'チャーハン・鉄板ごはん', zh: '炒饭/铁板饭' },
  'menu:rice-noodle:rice-noodle.bibimbap': { ja: 'ビビンバ・盛り付け型', zh: '拌饭/组装型' },
  'menu:rice-noodle:rice-noodle.pot-rice': { ja: '釜飯（注文後炊飯）', zh: '锅饭（现煮）' },
  'menu:rice-noodle:rice-noodle.shaped-rice': { ja: 'キンパ・おにぎり', zh: '紫菜包饭/饭团' },
  'menu:rice-noodle:rice-noodle.porridge': { ja: 'おかゆ', zh: '粥' },
  'menu:rice-noodle:rice-noodle.soup-noodle': { ja: '汁麺（温）', zh: '汤面（热）' },
  'menu:rice-noodle:rice-noodle.dry-noodle': { ja: '和え麺・汁なし麺', zh: '拌面/干面' },
  'menu:rice-noodle:rice-noodle.pan-noodle': { ja: '焼きそば・炒め麺', zh: '炒面' },
  'menu:rice-noodle:rice-noodle.cold-noodle': { ja: '冷麺', zh: '冷面' },
  'menu:rice-noodle:rice-noodle.tteokbokki': { ja: 'トッポッキ・餅料理', zh: '炒年糕·年糕料理' },
  'menu:rice-noodle:rice-noodle.dumpling': { ja: '餃子・点心', zh: '饺子·点心' },
  'menu:intl:intl.pasta-dry': { ja: 'ドライパスタ', zh: '干意面' },
  'menu:intl:intl.pasta-fresh': { ja: '生パスタ', zh: '鲜意面' },
  'menu:intl:intl.pasta-filled': {
    ja: '詰め物パスタ（ラビオリ・トルテッリーニ）',
    zh: '夹馅意面（意式饺子·意式馄饨）',
  },
  'menu:intl:intl.pasta-baked': { ja: 'オーブン焼きパスタ', zh: '焗烤意面' },
  'menu:intl:intl.risotto-grain': { ja: 'リゾット・グレイン', zh: '烩饭·谷物碗' },
  'menu:intl:intl.pizza-flatbread': { ja: 'ピザ・フラットブレッド', zh: '披萨·薄饼' },
  'menu:intl:intl.burger-sandwich': {
    ja: 'バーガー・サンドイッチ・ラップ',
    zh: '汉堡·三明治·卷饼',
  },
  'menu:intl:intl.main-salad': { ja: 'メインサラダ', zh: '主菜沙拉' },
  'menu:intl:intl.egg-brunch': { ja: 'ブランチの卵料理', zh: '早午餐蛋料理' },
  'menu:soup:soup.clear': { ja: '澄んだスープ', zh: '清汤' },
  'menu:soup:soup.bone-broth': { ja: '骨だしスープ（長時間）', zh: '骨汤（长时间熬煮）' },
  'menu:soup:soup.gukbap': { ja: 'クッパ', zh: '汤饭' },
  'menu:soup:soup.spicy-seafood': { ja: '海鮮辛味スープ（時価）', zh: '辣鱼/海鲜汤（时价）' },
  'menu:soup:soup.whole': { ja: '丸ごと素材の滋養スープ', zh: '整料滋补汤' },
  'menu:soup:soup.jjigae': { ja: 'チゲ（土鍋1〜2人）', zh: '炖锅（砂锅1-2人）' },
  'menu:soup:soup.hearty': { ja: '辛口・とろみ系', zh: '辣味浓汤（解酒类）' },
  'menu:soup:soup.jeongol': { ja: '鍋（卓上・複数人）', zh: '桌上火锅（多人）' },
  'menu:soup:soup.shabu': { ja: 'しゃぶしゃぶ・鍋（客が調理）', zh: '涮锅/寿喜锅（客人自煮）' },
  'menu:side:side.banchan': { ja: '常備菜・漬物', zh: '小菜/腌菜' },
  'menu:side:side.namul': { ja: 'ナムル・和え物・冷菜', zh: '凉拌/冷菜' },
  'menu:side:side.pancake': { ja: 'チヂミ', zh: '煎饼' },
  'menu:side:side.fried': { ja: '揚げ物サイド', zh: '油炸小食' },
  'menu:side:side.grilled': { ja: 'グリルサイド', zh: '烤制配菜' },
  'menu:side:side.salad': { ja: 'サラダ', zh: '沙拉' },
  'menu:side:side.soup': { ja: 'スープ・ポタージュ', zh: '汤/浓汤' },
  'menu:side:side.bread': { ja: 'パン・スターター', zh: '面包/开胃' },
  'menu:side:side.dip': { ja: 'ディップ・スプレッド', zh: '蘸酱/涂抹酱' },
  'menu:anju:anju.dry': { ja: '乾き物・基本のつまみ', zh: '干货/基础下酒菜' },
  'menu:anju:anju.fried': { ja: '揚げ物つまみ', zh: '油炸下酒菜' },
  'menu:anju:anju.skewer': { ja: '焼き・串', zh: '烤串' },
  'menu:anju:anju.hot-pot': { ja: '鍋（つまみ系）', zh: '汤锅（下酒）' },
  'menu:anju:anju.stir-fry': { ja: '辛い炒めつまみ', zh: '辣炒下酒菜' },
  'menu:anju:anju.pancake': { ja: 'チヂミ（マッコリと）', zh: '煎饼（配米酒）' },
  'menu:anju:anju.raw': { ja: '刺身・冷菜', zh: '生食/冷盘' },
  'menu:anju:anju.steamed': { ja: '蒸し・茹で肉', zh: '蒸/白切肉' },
  'menu:anju:anju.finger': { ja: 'バーつまみ・フィンガーフード', zh: '酒吧小食/手抓食' },
  'menu:anju:anju.finish': { ja: '〆の麺・ごはん', zh: '收尾面/饭' },
  'menu:dessert:dessert.baked': { ja: '焼き菓子', zh: '烘焙点心' },
  'menu:dessert:dessert.cake': { ja: 'ケーキ', zh: '蛋糕' },
  'menu:dessert:dessert.tart': { ja: 'タルト・パイ', zh: '挞/派' },
  'menu:dessert:dessert.pastry': { ja: 'パン・ペストリー', zh: '面包/酥点' },
  'menu:dessert:dessert.frozen': { ja: '冷菓・かき氷', zh: '冷冻甜品/刨冰' },
  'menu:dessert:dessert.cup': { ja: 'カップデザート', zh: '杯装甜点' },
  'menu:dessert:dessert.tteok': { ja: '餅・韓菓', zh: '年糕/韩果' },
  'menu:dessert:dessert.fried': { ja: '揚げデザート', zh: '油炸甜点' },
  'menu:dessert:dessert.plated': { ja: 'プレートデザート', zh: '现制摆盘甜点' },
  'menu:drinks:drinks.espresso': { ja: 'エスプレッソ系', zh: '意式浓缩饮品' },
  'menu:drinks:drinks.filter': { ja: 'フィルター・コールドブリュー', zh: '手冲/冷萃' },
  'menu:drinks:drinks.variation': { ja: 'バリエーションコーヒー', zh: '特调咖啡' },
  'menu:drinks:drinks.non-coffee-latte': { ja: 'ノンコーヒーラテ', zh: '非咖啡拿铁' },
  'menu:drinks:drinks.tea': { ja: 'お茶（抽出）', zh: '茶（冲泡）' },
  'menu:drinks:drinks.traditional-tea': { ja: '伝統茶・漢方茶', zh: '传统茶/药茶' },
  'menu:drinks:drinks.juice-ade': { ja: 'ジュース・エード', zh: '果汁/气泡饮' },
  'menu:drinks:drinks.smoothie': { ja: 'スムージー・フラッペ', zh: '奶昔/冰沙' },
  'menu:drinks:drinks.shake': { ja: 'シェイク・乳飲料', zh: '奶昔/乳饮' },
  'menu:drinks:drinks.bottled': { ja: '瓶・缶飲料（仕入れ）', zh: '瓶装饮料（采购）' },
  'menu:drinks:drinks.cocktail': {
    ja: 'カクテル・ハイボール（店内調製）',
    zh: '鸡尾酒·嗨棒（店内调制）',
  },
  // ── 2026-11-01 메뉴 보강 (대표 명세 2장): 초밥·타파스, 국제·서양 메인 묶음 세부 ──
  'menu:main:main.sushi': { ja: '寿司・握り・刺身', zh: '寿司·握寿司·刺身' },
  'menu:side:side.tapas': { ja: 'タパス・スモールプレート', zh: '塔帕斯·小盘菜' },
  'menu:intl:intl.risotto': { ja: 'リゾット', zh: '意式烩饭' },
  'menu:intl:intl.orzo': { ja: 'オルゾ', zh: '米粒面' },
  'menu:intl:intl.farro': { ja: 'ファッロ', zh: '法罗小麦' },
  'menu:intl:intl.quinoa-bowl': { ja: 'キヌアのグレインボウル', zh: '藜麦谷物碗' },
  'menu:intl:intl.pizza-napoli': { ja: 'ナポリ風ピザ', zh: '那不勒斯披萨' },
  'menu:intl:intl.pizza-roman': { ja: 'ローマ風ピザ', zh: '罗马披萨' },
  'menu:intl:intl.pizza-al-taglio': { ja: 'ピッツァ・アル・ターリオ', zh: '方形切块披萨' },
  'menu:intl:intl.focaccia': { ja: 'フォカッチャ', zh: '佛卡夏' },
  'menu:intl:intl.flatbread': { ja: 'フラットブレッド', zh: '烤薄饼' },
  'menu:intl:intl.burger': { ja: '手作りバーガー', zh: '手工汉堡' },
  'menu:intl:intl.club-sandwich': { ja: 'クラブサンド', zh: '总汇三明治' },
  'menu:intl:intl.open-sandwich': { ja: 'オープンサンド', zh: '开放式三明治' },
  'menu:intl:intl.baguette-sandwich': { ja: 'バゲットサンド', zh: '法棍三明治' },
  'menu:intl:intl.salad-protein': { ja: 'プロテインサラダ', zh: '蛋白质沙拉' },
  'menu:intl:intl.salad-grain': { ja: 'グレインサラダ', zh: '谷物沙拉' },
  'menu:intl:intl.salad-warm': { ja: 'ウォームサラダ', zh: '温沙拉' },
}
